/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description Draft Claim Actions button component
 */
import { MoreOne } from '@icon-park/react';
import { Dropdown, App, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

import useDeleteDraftClaim from 'hooks/claim/mutate/useDeleteDraftClaim';
import { MODAL_TYPES } from 'components/widgets/modal';
import { getEditDraftClaimPath } from 'utils/router';
import { DRAFT_CLAIM_DISCARD } from 'app-constants/claims/claimFiling';

export interface IProps {
	claimId: string;
	claimType: ClaimFiling.IClaimType;
	reload: () => void;
	isDraftClaim: boolean;
}

/**
 * DraftClaimActions - Edit and Discard actions for draft claims
 */
const DraftClaimActions: React.FC<IProps> = ({ claimId, claimType, reload, isDraftClaim }) => {
	const navigate = useNavigate();
	const { modal } = App.useApp();
	const { mutateAsync: deleteDraftClaim } = useDeleteDraftClaim();

	const handleEdit = () => {
		navigate(getEditDraftClaimPath(claimType, claimId));
	};

	const handleDelete = () => {
		modal.confirm({
			...MODAL_TYPES.confirm,
			...DRAFT_CLAIM_DISCARD,
			okButtonProps: { danger: true },
			onOk: async () => {
				await deleteDraftClaim({ claimId }, { onSuccess: reload });
			},
		});
	};

	const menuItems = [
		{
			key: 'edit',
			label: 'Edit',
			onClick: handleEdit,
		},
		{
			key: 'delete',
			label: 'Delete',
			danger: true,
			onClick: handleDelete,
		},
	];

	if (!isDraftClaim) {
		return null;
	}

	return (
		<Dropdown menu={{ items: menuItems }} trigger={['click']} placement='bottomRight'>
			<Button icon={<MoreOne />} />
		</Dropdown>
	);
};

export default DraftClaimActions;
